export const NAV_ITEMS = {
  CONVERSATIONS_SUBNAV: {
    label: 'Conversations',
    path: '/inboxes',
    requiredScopes: ['member', 'calendar_user', 'video'],
    requiredRoles: [],
    rejectIfHasScopes: ['org_admin'],
    iconSRC: 'conversations',
    height: 18,
    width: 16
  },

  CONVERSATIONS_SUBNAV_ADMIN: {
    label: 'Conversations',
    path: '/conversations/analysis',
    additionalPaths: ['/inboxes'],
    requiredScopes: ['org_admin'],
    requiredRoles: ['Reporting'],
    hasAllGates: ['has_insights'],
    iconSRC: 'conversations',
    external: true,
    height: 18,
    width: 16
  },

  CONVERSATIONS_SUBNAV_NO_ANALYSIS: {
    label: 'Conversations',
    path: '/inboxes',
    requiredScopes: ['org_admin'],
    requiredRoles: [],
    rejectIfHasGates: ['has_insights'],
    iconSRC: 'conversations',
    external: true,
    height: 18,
    width: 16
  },

  PLAYBOOKS_BOTS: {
    label: 'Playbooks',
    path: '/playbooks',
    additionalPaths: ['/automation'],
    requiredScopes: ['org_admin'],
    requiredRoles: ['Playbooks'],
    iconSRC: 'bot-2',
    external: true,
    height: 18,
    width: 18
  },

  PLAYBOOKS_SEQUENCES: {
    label: 'Sequences',
    path: '/playbooks',
    requiredScopes: ['member'],
    requiredRoles: [],
    rejectIfHasScopes: ['org_admin'],
    rejectIfHasGates: ['has_calendar_user_license'],
    iconSRC: 'email-send',
    external: true,
    height: 18,
    width: 18
  },

  CONTACTS_SUBNAV: {
    label: 'Visitors',
    path: '/contacts',
    additionalPaths: ['/live', '/accounts', '/audiences'],
    requiredScopes: ['member'],
    requiredRoles: [],
    rejectIfHasGates: ['has_calendar_user_license'],
    rejectIfHasScopes: ['org_admin'],
    iconSRC: 'contacts',
    external: true,
    height: 18,
    width: 18
  },

  CONTACTS_SUBNAV_AUDIENCES: {
    label: 'Visitors',
    path: '/audiences',
    additionalPaths: ['/contacts', '/live', '/accounts'],
    requiredScopes: ['org_admin'],
    requiredRoles: ['Playbooks'],
    hasAllGates: ['AUDIENCE'],
    rejectIfHasGates: ['has_calendar_user_license'],
    iconSRC: 'contacts',
    external: true,
    height: 18,
    width: 16
  },

  CONTACTS_SUBNAV_ADMIN_NO_AUDIENCES: {
    label: 'Visitors',
    path: '/contacts',
    additionalPaths: ['/live', '/accounts'],
    requiredScopes: ['org_admin'],
    requiredRoles: [],
    rejectIfHasGates: ['AUDIENCE', 'has_calendar_user_license'],
    iconSRC: 'contacts',
    external: true,
    height: 18,
    width: 16
  },

  REPORTS: {
    label: 'Reports',
    path: '/reports',
    requiredScopes: ['member'],
    requiredRoles: ['Reporting', 'Playbooks'],
    iconSRC: 'bar-chart',
    external: true,
    height: 18,
    width: 18
  }
}

export const DEFAULT_ITEMS = [
  'HOME',
  'CONVERSATIONS_SUBNAV',
  'CONVERSATIONS_SUBNAV_ADMIN',
  'CONVERSATIONS_SUBNAV_NO_ANALYSIS',
  'CONTACTS_SUBNAV',
  'CONTACTS_SUBNAV_AUDIENCES',
  'CONTACTS_SUBNAV_ADMIN_NO_AUDIENCES',
  'PLAYBOOKS_SEQUENCES',
  'PLAYBOOKS_BOTS',
  'REPORTS',
]


// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/config.js